import React, { useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Input,
  Row,
  Col,
  Navbar,
  NavbarBrand,
  Container,
} from "reactstrap";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { SubDirectory } from "utils/defaults";
import { SAlert } from "utils/functions";
import { SMSAlert } from "utils/defaults";
import { SAText } from "utils/functions";
import { getDeviceFingerprint } from "utils/functions";
import { APPADMINCOOKIE } from "utils/defaults";
import { useAuth } from "components/custom/authprovider";
import { ADMIN_LOGIN1 } from "graphql/admin/mutations/users";
import { ADMIN_LOGIN2 } from "graphql/admin/mutations/users";
import '../../assets/css/admin.css';

function AdminLogin()  { 
const {setWT, setIsAuthenticated}  = useAuth();
const [adminLogin1] = useMutation(ADMIN_LOGIN1); 
const [adminLogin2] = useMutation(ADMIN_LOGIN2); 
const [username, setUserName] = useState("");

let history = useHistory();

  const TryLogin = () => {
    if(username !== undefined){
      adminLogin1({ variables: {loginHandle: username}})
      .then((r1) => {
        if(r1.data.adminLogin1.status){
          SendAlert();
        }
        else{
          SAText("Error", r1.data.adminLogin1.error, "error");
        }
      })
      .catch((err) => {
        SAText("Error", err, "error");
      })
      .finally(() =>{
        //TODO: set loading
      });
    }
    else{
      SAText("Invalid Username", "A valid username is requried to login", "error");
    }
  };

  const SendAlert = () => {
    SAlert(SMSAlert.title, "text", SMSAlert.label, SMSAlert.icon, (v) => {
      adminLogin2({ variables: {loginHandle: username, code: v, fingerprint: getDeviceFingerprint()} })
      .then((r2) => {
        if(r2.data.adminLogin2.status){
          const TheCookie ={
            wt: r2.data.adminLogin2.token,
            dt: r2.data.adminLogin2.dt,
            p: "admin",
            a: r2.data.adminLogin2.a
          };
          const token = localStorage.setItem( APPADMINCOOKIE, JSON.stringify(TheCookie) );

          setWT({ 
            wt: r2.data.adminLogin2.token, 
            dt: r2.data.adminLogin2.dt,
            p: "admin",
            a: r2.data.adminLogin2.a
          });

          setIsAuthenticated({ token });

          history.push("/" + SubDirectory + "admin/");
        }
        else
          SAText("Error", r2.data.adminLogin2.error, "error", () => SendAlert());
      });
    });
  };

  const onEnter = (event) => event.key === 'Enter' && TryLogin();

    return (
      <div className="admin-wrapper">
      <Navbar className="navbar" expand="md">
      <NavbarBrand href="/" className="navbar-brand">WOW Cloud Network Admin Panel</NavbarBrand>
      </Navbar>

      <Container fluid className="content">
        <Row className="justify-content-center">
          <Col sm="12" md="6" lg="4">
            <Card className="card-dark login-card">
              <CardHeader className="card-header-dark">
                <CardTitle tag="h5">Login Required</CardTitle>
              </CardHeader>
              <CardBody>
                <FormGroup>
                  <label className="subTitle">Username</label>
                  <Input
                    placeholder="Username"
                    type="text"
                    autoComplete="off"
                    onChange={(e) => setUserName(e.target.value)}
                    value={username}
                    onKeyDown={onEnter}
                    autoFocus
                  />
                </FormGroup>
              </CardBody>
              <CardFooter>
                <Button
                  className="btn-fill"
                  color="info"
                  style={{ width: "100%" }}
                  onClick={TryLogin}
                >
                  Login
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    );
  }

export default AdminLogin;